import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  calculateRemainingTime,
  isTimerActive,
  getMfaCodeResendTime,
  formatTimerDigits,
} from 'utils/mfaTimer';
import type { RootState } from 'store/types';

export const useMfaTimer = () => {
  const authState = useSelector((state: RootState) => state.authState);
  const [remainingSeconds, setRemainingSeconds] = useState(0);

  const mfaCodeResendTime = getMfaCodeResendTime(authState);

  useEffect(() => {
    if (!mfaCodeResendTime) {
      setRemainingSeconds(0);
      return;
    }

    const updateTimer = () => {
      const remaining = calculateRemainingTime(mfaCodeResendTime);
      setRemainingSeconds(remaining);
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [mfaCodeResendTime]);

  const timerActive = mfaCodeResendTime
    ? isTimerActive(mfaCodeResendTime)
    : false;
  const formattedTimerDigits =
    remainingSeconds > 0 ? formatTimerDigits(remainingSeconds) : '';

  return {
    remainingSeconds,
    isTimerActive: timerActive,
    formattedTimerDigits,
    mfaCodeResendTime,
  };
};
